import { Grid, Typography } from '@mui/material';
import { TooltipInfo } from '../../../../../components/TooltipInfo';
import { CustomEditor } from './CustomEditor.component';

export const GalleryEditor: React.FC<{
  code: string;
  setCode: (value: React.SetStateAction<string>) => void;
}> = ({ code, setCode }) => {
  return (
    <Grid item xs={4} sx={
      {
        padding: '10px',
      }
    }>
      <Typography
        component="h1"
        variant="h6"
        color="inherit"
        noWrap
        sx={{
          flexGrow: 1,
          marginBottom: '10px',
        }}
      >
        Edytuj galerię
        <TooltipInfo
          message={
            <div>
              <p>Edytuj główny komponent galerii.</p>
              <p>$items - zmienna w której pojawią się dodane pozycje.</p>
            </div>
          }
        />
      </Typography>
      <CustomEditor code={code} setCode={setCode} />
    </Grid>
  );
};
